<template>
<header class="investor-header" :class="navbarClass">
	<Popper v-if="user.is_investor == 't'" target_id="nav-dropdown-button" :append_to_body="true" placement="bottom-end" ref="dropdown">
		<div class="dropdown">
			<router-link :to="{name: 'account'}">
				Your Account
			</router-link>
			<!-- <router-link :to="{name: 'messages'}">
                Messages <span v-if="unreadTickets>0" class="badge">{{unreadTickets}}</span>
            </router-link> -->
            <a @click="pushToSignout">
				Sign Out
			</a>
		</div>
	</Popper>
	<RequestSigninModal ref="signinModal" @confirm="onSigninRequestConfirm" @error="onSigninError"></RequestSigninModal>
	<MessageModal ref="messageModal" title='Kolkin Sign In' message="Check your email for a sign-in link."></MessageModal>
	<MessageModal ref="errorMessageModal" title='Kolkin Sign In' message="This email is not linked to your investor account."></MessageModal>
    <section>
        <nav>
            <a href="/">
                <i class="icon icon-kolkin"></i>
                <span class="kolkin-font">Kolkin</span>
            </a>

            <div v-if="user.is_investor == 't'" class="navbar-right">
				<!-- <router-link :to="{name: 'updates'}">
                    Investor Update
                </router-link> -->
				<a id="nav-dropdown-button" @click="dropdownClick" class="print-hide">
					Account 
                    <!-- <span v-if="unreadTickets>0" class="badge">{{unreadTickets}}</span> -->
				</a>
                
            </div>
			<div v-else class="navbar-right">
				<a @click="requestSignin">Sign-in</a>
			</div>
        </nav>
    </section>

</header>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import axios from "axios";
import Popper from "@/../submodules/vue-base/components/Popper";
import RequestSigninModal from "@/components/navbar/RequestSigninModal";
import MessageModal from "@/../submodules/vue-base/components/MessageModal";

export default {
    name: "Navbar",

    components: {
        Popper,
		RequestSigninModal,
		MessageModal
    },

    data() {
        return {
            navbarClass: "navbar-text-white"
        }
    },

    created() {
        window.addEventListener('scroll', this.handleScroll);
    },

    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },

    methods: {
		
        dropdownClick() {
            this.$refs.dropdown.toggle();
        },

        handleScroll(event) {
            var isLight = false;
            var scrollTop = window.pageYOffset;
            if (scrollTop == 0) {
                this.navbarClass = "navbar-text-white";
            } else {
                this.navbarClass = "navbar-light";
            }
        },

		requestSignin() {
			this.$refs.signinModal.open();
		},

        pushToSignIn() {
            window.location = '/signin/investor';
        },

        pushToSignout() {
            this.$store.dispatch("signout").then(function () {
                window.location = '/investor';
            });
        },

		onSigninRequestConfirm(){
			this.$refs.messageModal.open();
		},

		onSigninError(){
			this.$refs.errorMessageModal.open();
		}

    },
    computed: {
        userSessionEmpty() {
            return this.user && Object.keys(this.user).length === 0 && this.user.constructor === Object
        },
        isPhysician() {
            return this.user.type == "physician"
        },

        ...mapGetters(['user',"unreadTickets"])
    }
};
</script>
